import { EnvelopeOpenIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

function ChipButton({ children, onClick, title, className = "" }) {
  return (
    <button
      type="button"
      className={`cv-mail-chip ${className}`.trim()}
      title={title}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
    >
      {children}
    </button>
  );
}

/**
 * Case HEADER mail tags: only Mailtråd.
 * Per-email innkommende/utgående chips belong in the timeline / Moduler tab, not here.
 */
export function CaseEmailNoticeChips({ emails, hasThread, onOpenThread }) {
  const { t } = useTranslation();
  const list = Array.isArray(emails)
    ? emails.filter((row) => row?.id || row?.graph_message_id)
    : [];

  if (!hasThread && list.length === 0) return null;

  const label = t("case.mail_thread.open");

  return (
    <div className="cv-mail-chips" role="group" aria-label={label}>
      <ChipButton onClick={() => onOpenThread?.()} title={label} className="is-thread">
        <EnvelopeOpenIcon className="h-3.5 w-3.5" aria-hidden="true" />
        <span className="cv-mail-chip-label">{label}</span>
      </ChipButton>
    </div>
  );
}
